import ENDPOINTS from '../../const/endpoints';
export var profileCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return [ENDPOINTS.profile, { accountId: accountId, accountIdType: accountIdType }];
};
